<section class="explore">
  <ion-text color="dark" class="ion-text-center">
    <h2 class="explore-title">{{ node?.title }}</h2>
  </ion-text>

  <ion-grid>
    <ion-row>
      <ion-col size="6" [sizeLg]="columnCount" *ngFor="let item of node?.items">
        <ion-card (click)="linkItem(item)" [class.has-link]="item.hyperlink">
          <app-img-format
            *ngIf="item.img?.url"
            [src]="item.img.url"
            [aspectRatio]="'1:1'"
            [disableLazyLoad]="true"></app-img-format>
          <ion-card-header>
            <ion-card-title>{{ item.subtitle }}</ion-card-title>
          </ion-card-header>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</section>
